import Vue from 'vue'
import { v4 as uuid } from 'uuid';

const character = {
  namespaced: true,
  state: {
    xp: 0,
    name: '',
    bondTrackTicks: 0,
    stats: {
      edge: 1,
      heart: 1,
      iron: 1,
      shadow: 1,
      wits: 1,
    },

    vitals: {
      momentum: {
        current: 2,
        characterMax: 10,
        reset: 2,
        max: 10,
        min: -5,
      },
      health: {
        current: 5,
        max: 5,
        min: 0,
      },
      spirit: {
        current: 5,
        max: 5,
        min: 0,
      },
      supply: {
        current: 5,
        max: 5,
        min: 0,
      },
    },
  },


  getters: {
    healthCurrent(state) {
      return state.vitals.health.current;
    },
    spiritCurrent(state) {
      return state.vitals.spirit.current;
    },
    supplyCurrent(state) {
      return state.vitals.supply.current;
    },
    healthMax(state) {
      return state.vitals.health.max;
    },
    momentumCurrent(state) {
      return state.vitals.momentum.current;
    },
    momentumMax(state) {
      // TODO: account for debilities:
      // -1 per marked debility
      return state.vitals.momentum.max;
    },
    momentumMin(state) {
      return state.vitals.momentum.min;
    },
    momentumCharacterMax(state) {
      return state.vitals.momentum.characterMax;
    },
    momentumReset(state) {
      // TODO: account for debilities:
      // == 1 for one debility marked
      // == 0 for more than one debility marked
      return state.vitals.momentum.reset;
    },
    momentumRange(state, getters) {
      //create an inclusive range from min and max
      const fullRange = Array.from(
        {
          length: getters.momentumCharacterMax - getters.momentumMin + 1,
        },
        (v, k) => {
          return k + getters.momentumMin;
        },
      );

      const relevantRange = fullRange.map(v => {
        if (v == 0) {
          return '0';
        }
        if (
          v == getters.momentumMin ||
          v == getters.momentumCharacterMax ||
          v == getters.momentumReset
        ) {
          return v;
        }
        return null;
      });

      return relevantRange;
      //return [
      //-5,
      //null,
      //null,
      //null,
      //null,
      //'0',
      //null,
      //2,
      //null,
      //null,
      //null,
      //null,
      //null,
      //null,
      //null,
      //10,
      //];
    },
  },

  mutations: {
    setCharacterName(state, value) {
      state.name = value;
    },

    setCharacterXP(state, value) {
      state.xp = value
    },

    addBondTick(state) {
      state.bondTrackTicks += 1;
    },
    removeBondTick(state) {
      state.bondTrackTicks -= 1;
    },

    setEdge(state, value) {
      state.stats.edge = value;
    },
    setHeart(state, value) {
      state.stats.heart = value;
    },
    setIron(state, value) {
      state.stats.iron = value;
    },
    setShadow(state, value) {
      state.stats.shadow = value;
    },
    setWits(state, value) {
      state.stats.wits = value;
    },

    setHealthCurrent(state, value) {
      state.vitals.health.current = value;
    },

    setSpiritCurrent(state, value) {
      state.vitals.spirit.current = value;
    },

    setSupplyCurrent(state, value) {
      state.vitals.supply.current = value;
    },

    setMomentumCurrent(state, value) {
      state.vitals.momentum.current = value;
    },
    setMomentumReset(state, value) {
      state.vitals.momentum.reset = value;
    },
    resetMomentum(state, value) {
      state.vitals.momentum.current = value;
    },
    setCharacterMaxMomentum(state, value) {
      state.vitals.momentum.characterMax = value;
    },
  },

  actions: {
    addBond({commit}) {
      commit('addBondTick')
    },
    removeBond({commit}) {
      commit('removeBondTick')
    },

    rollChallenge({commit}) {
      const result = Vue.rolling.challengeRoll(0)

      const entry = {
        uuid: uuid(),
        entryType: 'genericChallengeRoll',
        result: result,
        createdAt: new Date().getTime(),
      };
      commit('log/addRollEntry', entry, { root: true })
    },

    rollStat({state, commit}, payload) {
      let statBonus
      if ( // is a 'vital'
        (payload.stat === 'health') ||
        (payload.stat === 'spirit') ||
        (payload.stat === 'supply')
      ) {
        statBonus = state.vitals[payload.stat].current
        } else { // is a 'stat'
        statBonus = state.stats[payload.stat]
      }

      const statRolled = payload.stat

      const result = Vue.rolling.challengeRoll(statBonus)

      const entry = {
        uuid: uuid(),
        entryType: 'roll',
        statBonus: statBonus,
        statRolled: statRolled,
        result: result,
        createdAt: new Date().getTime(),
      };
      commit('log/addRollEntry', entry, { root: true })
    },

    setName({commit}, value) {
      commit('setCharacterName', value);
    },

    setXP({commit}, value) {
      commit('setCharacterXP', value);
    },

    setStat({commit}, params) {
      // uppercase first letter
      const setterName = `set${params.stat.charAt(0).toUpperCase() +
        params.stat.slice(1)}`;
      commit(setterName, params.value);
    },

    setVital({commit}, params) {
      // uppercase first letter
      const setterName = `set${params.vital.charAt(0).toUpperCase() +
        params.vital.slice(1)}Current`;
      commit(setterName, params.value);
    },

    setMomentum({commit}, value) {
      commit('setMomentumCurrent', value);
    },
    setCharacterMaxMomentum({commit}, value) {
      commit('setCharacterMaxMomentum', value);
    },
    setMomentumReset({commit}, value) {
      commit('setMomentumReset', value);
    },
    resetMomentum({commit, getters}) {
      const value = getters.momentumReset;
      commit('resetMomentum', value);
    },
  }
}

export default character;
